import classNames from 'classnames';

import ActionMenu from 'common/ActivityChip/ActionMenu';
import { getActivityActions } from 'common/ActivityChip/ActionMenu/actionMenuFactory';
import { useActivityMutations } from 'common/ActivityChip/ActionMenu/useActivityMutation';

import styles from 'common/ActivityChip/styles.module.css';

const RroTimeOffAvailabilityDisabledLayout = ({
	config,
	isSelected,
	isStartInTimeWindow = true,
	isEndInTimeWindow = true,
	suppressNativeTitle = false,
}) => {
	const { renderType, header, fromTimestamp, toTimestamp, raw, crewMemberId } = config;

	const { toggleAvailability, updateAbsence, deleteAbsence, loading } = useActivityMutations();

	const activityActions = getActivityActions(
		{ ...raw, renderType, fromTimestamp, toTimestamp, crewMemberId },
		{
			onToggleAvailability: toggleAvailability,
			onUpdateAbsence: updateAbsence,
			onDeleteAbsence: deleteAbsence,
		}
	);

	const chipStyles = classNames(styles.activity, styles[renderType], {
		[styles.selected]: isSelected,
		[styles.openStart]: !isStartInTimeWindow,
		[styles.openEnd]: !isEndInTimeWindow,
	});

	return (
		<div title={suppressNativeTitle ? undefined : header} className={chipStyles}>
			<div className={styles.headerText}>{header}</div>
			<ActionMenu items={activityActions} isLoading={loading} />
		</div>
	);
};

export default RroTimeOffAvailabilityDisabledLayout;
